module.exports = __webpack_public_path__ + "img/sxsjs10.67964e39.png";